import React from "react";
import { Div, Text, Button } from "atomize";
import AnimateLink from "../common/AnimateLink";

const PodcastSubmitApplication = () => {
  return (
    <>
      <Div maxW="35.875rem" m="auto" textAlign="center">
        <Text
          textWeight="800"
          className="submit-podcast"
          m={{ b: "2rem", x: "auto" }}
          maxW={{ xs: "14.125rem", md: "100%" }}
        >
          Interested in being a guest on the DTC POD?
        </Text>
        <Div>
          <AnimateLink to="https://form.typeform.com/to/GhGUsElA?typeform-medium=embed-snippet">
            <Button
              bg="primary"
              p="1.125rem 1.875rem"
              textWeight={{ xs: "800", md: "600" }}
              textSize="20px"
              hoverBg="#FFCB6F"
              textColor="black"
              h="3.5rem"
              rounded="2px"
              m="auto"
            >
              Submit Guest Application
            </Button>
          </AnimateLink>
        </Div>
      </Div>
    </>
  );
};

export default PodcastSubmitApplication;
